import { render, staticRenderFns } from "./momentsRead.vue?vue&type=template&id=6d6a46c8&lang=pug"
import script from "./momentsRead.vue?vue&type=script&lang=js"
export * from "./momentsRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports